import type { DocNode } from '@atlaskit/adf-schema/doc';

/**
 * Returns true if the ADF document has no non-empty block nodes.
 *
 * A document is considered empty when every top-level node either has no
 * `content` array or has a `content` array with zero children. This correctly
 * treats a single empty paragraph ({ type: 'paragraph', content: [] }) as
 * empty, matching the editor's own notion of an empty document.
 */
export const isAdfDocEmpty = (doc: DocNode | undefined): boolean =>
	!doc?.content?.some(
		(node) => 'content' in node && Array.isArray(node.content) && node.content.length > 0,
	);
